module.exports = {
  bcBlue600: 'rgb(12, 122, 192)',
  bcBlue500: 'rgb(87, 183, 244)',
  bcBlue400: 'rgb(183, 224, 251)',
  bcBlue700: 'rgb(8, 85, 134)',
  bcBlue800: 'rgb(4, 46, 72)',
  bcCoral600: 'rgb(192, 58, 12)',
  bcCoral500: 'rgb(244, 127, 87)',
  bcCoral400: 'rgb(251, 200, 183)',
  bcCoral700: 'rgb(134, 41, 8)',
  bcCoral800: 'rgb(72, 22, 4)',
  bcGreen600: 'rgb(45, 159, 98)',
  bcGreen500: 'rgb(116, 216, 162)',
  bcGreen700: 'rgb(32, 111, 69)',
  bcGrey600: 'rgb(84, 106, 120)',
  bcGrey500: 'rgb(105, 133, 150)',
  bcGrey400: 'rgb(135, 157, 171)',
  bcGrey300: 'rgb(165, 181, 192)',
  bcGrey200: 'rgb(195, 206, 213)',
  bcGrey100: 'rgb(225, 231, 234)',
  bcGrey50: 'rgb(240, 243, 245)',
  bcGrey700: 'rgb(63, 80, 90)',
  bcGrey800: 'rgb(42, 53, 60)',
  bcGrey900: 'rgb(21, 27, 30)',
  bcPurple600: 'rgb(79, 12, 192)',
  bcPurple500: 'rgb(146, 87, 244)',
  bcPurple400: 'rgb(208, 183, 251)',
  bcPurple700: 'rgb(55, 8, 134)',
  bcPurple800: 'rgb(30, 4, 72)',
  bcRed600: 'rgb(179, 32, 35)',
  bcRed500: 'rgb(229, 110, 112)',
  bcRed700: 'rgb(127, 23, 25)',
  bcTeal600: 'rgb(12, 182, 192)',
  bcTeal500: 'rgb(87, 236, 244)',
  bcTeal400: 'rgb(183, 247, 251)',
  bcTeal700: 'rgb(8, 127, 134)',
  bcTeal800: 'rgb(4, 68, 72)',
  bcYellow600: 'rgb(244, 167, 0)',
  bcYellow500: 'rgb(255, 211, 116)',
  bcYellow700: 'rgb(183, 125, 0)',
  bcYellow400: 'rgb(255, 243, 219)'
};



// WEBPACK FOOTER //
// ./src/brand-colors.js